import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import UpdateIdentity from "../UpdateIdentity";
import ConfirmRemoteConsentModal from "./ConfirmRemoteConsentModal/ConfirmRemoteConsentModal";
import useCustomRouting from "../../hooks/useCustomRouting";
import axiosInstance from "../../api/axios";
import "react-loading-skeleton/dist/skeleton.css";
import BackButton from "./BackBuuton/BackButton";
import ProfileCard from "./ProfileCard/ProfileCard";
import DetailsTabs from "./DetailsTabs/DetailsTabs";
import useTracker from "../../hooks/useTracker";
import { setLoader } from "../../features/LoaderSlice";
import DeleteIdentityModal from "./DeleteIdentityModal";
import { errorToast, successToast } from "../../utils/notifications";
import { addUserDetails } from "../../features/UserDetailsSlice";
import { nanoid } from "@reduxjs/toolkit";
import { useLocation } from "react-router-dom";
import { EMPTY_STRING, NULL_VALUE } from "../../utils/constants";
import CocoLinkGeneratorModal from "./CocoLinkGeneratorModal/CocoLinkGeneratorModal";
const DetailPage = ({ baseLoading }) => {
  const { pageTracker, trackDeleteIdentity } = useTracker();
  const dispatch = useDispatch();
  const userDetails = useSelector(
    (state) => state.userDetailsReducer.userDetail
  );
  const trackerDeatils = useSelector((state) => state?.TrackerReducer);
  const [loading, setLoading] = useState(baseLoading);
  const { redirectToPath } = useCustomRouting();
  const [identityDetails, setIdentityDetails] = useState();
  const [activeTab, setActiveTab] = useState(1);
  const [isSentConsentOpen, setIsSentConsentOpen] = useState(false);
  const [isUpdateOpen, setIsUpateOpen] = useState(false);
  const [isUnsavedUpdateOpen, setIsUnsavedUpdateOpen] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(
    !!trackerDeatils?.delete_form?.snowId,
  );
  const [isCocoLinkGeneratorOpen, setIsCocoLinkGeneratorOpen] = useState(false);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const controllerCodeValue = params.get("controller");
  const customerScope = params.get("customer_scope");
  const type = params.get("type");
  const value = params.get("value");
  const fetchData = async (url) => {
    const response = await axiosInstance.get(url);
    return response.data;
  };
  const getIdentityDetails = async () => {
    setLoading(true);

    const identityCheckApi = `check/${controllerCodeValue}/${customerScope}/${type}/${value}?debug=true`;
    const identityHistoryApi = `check/${controllerCodeValue}/${customerScope}/${type}/${value}/history?debug=true`;
    const identityCommunicationApi = `communication/${controllerCodeValue}/${customerScope}/${type}/${value}`;
    let identityData;
    try {
      const checkRes = await fetchData(identityCheckApi);
      identityData = { ...checkRes };
      dispatch(
        addUserDetails({
          id: nanoid(),
          controller_code: identityData?.digital_identity?.controller_code,
          customer_scope: identityData?.digital_identity?.customer_scope,
          type: identityData?.digital_identity?.type,
          value: identityData?.digital_identity?.value,
          language: identityData?.digital_identity?.language,
        }),
      );
    } catch (err) {
      const { message } = err?.data || {};
      errorToast(message, 150);
      setTimeout(() => {
        redirectToPath("/identity-management/");
      }, 500);
    }
    try {
      const historyRes = await fetchData(identityHistoryApi);
      identityData.digital_identity = {
        ...(identityData?.digital_identity || {}),
        ...(historyRes?.digital_identity || {}),
      };
      identityData.history = historyRes?.data_processing_authorizations;
    } catch (err) {}
    try {
      const communicationRes = await fetchData(identityCommunicationApi);
      identityData.communication = communicationRes?.communication || [];
    } catch (err) {}
    setIdentityDetails(identityData);
    dispatch(setLoader({ loading: false, label: "" }));
    setLoading(false);
  };

  useEffect(() => {
    if (!baseLoading) {
      if (
        location.search !== EMPTY_STRING &&
        controllerCodeValue !== NULL_VALUE &&
        controllerCodeValue !== EMPTY_STRING &&
        customerScope !== NULL_VALUE &&
        customerScope !== EMPTY_STRING &&
        type !== NULL_VALUE &&
        type !== EMPTY_STRING &&
        value !== NULL_VALUE &&
        value !== EMPTY_STRING
      ) {
        if (
          (controllerCodeValue || trackerDeatils?.controller_code) &&
          (customerScope || trackerDeatils?.customer_scope)
        )
          pageTracker({});
        getIdentityDetails();
      } else redirectToPath("/identity-management/");
    }
  }, [baseLoading]);

  const handleSendRemoteConsentCB = (status, refresh = false) => {
    setIsSentConsentOpen(status);
    if (refresh) {
      getIdentityDetails();
    }
  };
  const handleDeleteIdentity = async (snowId) => {
    try {
      setLoading(true);
      const { type, value } = userDetails;
      const response = await axiosInstance.post(
        `/delete_main_identity/${controllerCodeValue}/${customerScope}/${type}/${value}/${snowId}`
      );
      if (response?.data?.statusCode === 200) {
        successToast(
          response?.data?.message || "Successfully deleted the main identity"
        );
        trackDeleteIdentity({});
        redirectToPath("/identity-management");
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      if (err === 403) {
        errorToast("You don't have required permission to delete identity.");
        setOpenDeleteModal(false);
        trackDeleteIdentity({});
      } else
        errorToast(
          err?.data?.message ||
            "Failed to delete the mail identity, please try again"
        );
    }
  };

  return (
    <>
      <BackButton />
      <ProfileCard
        userDetails={identityDetails?.digital_identity}
        controllerCodeValue={controllerCodeValue}
        customerScope={customerScope}
        setIsSentConsentOpen={setIsSentConsentOpen}
        setIsUpateOpen={setIsUpateOpen}
        getUserDetails={getIdentityDetails}
        loading={loading}
        handleOpenDeleteModal={setOpenDeleteModal}
        setIsCocoLinkGeneratorOpen={setIsCocoLinkGeneratorOpen}
      />
      <DetailsTabs
        controllerCodeValue={controllerCodeValue}
        customerScope={customerScope}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        refresh={getIdentityDetails}
        details={identityDetails}
        loading={loading}
        setLoading={setLoading}
      />
      <UpdateIdentity
        isUpdateOpen={isUpdateOpen}
        setIsUpateOpen={setIsUpateOpen}
        user={{
          salutation: identityDetails?.digital_identity?.salutation,
          controllerCode: identityDetails?.digital_identity?.controller_code,
          customerScope: identityDetails?.digital_identity?.customer_scope,
          type: identityDetails?.digital_identity?.type,
          value: identityDetails?.digital_identity?.value,
          language: identityDetails?.digital_identity?.language,
          contactEmail: identityDetails?.digital_identity?.contact_email,
          first_name: identityDetails?.digital_identity?.first_name,
          last_name: identityDetails?.digital_identity?.last_name,
          title: identityDetails?.digital_identity?.title,
        }}
        getUserDetails={getIdentityDetails}
        isUnsavedUpdateOpen={isUnsavedUpdateOpen}
        setIsUnsavedUpdateOpen={setIsUnsavedUpdateOpen}
        refresh={getIdentityDetails}
      />
      <ConfirmRemoteConsentModal
        isSentConsentOpen={isSentConsentOpen}
        setIsSentConsentOpen={handleSendRemoteConsentCB}
        user={{
          controllerCode: identityDetails?.digital_identity?.controller_code,
          customerScope: identityDetails?.digital_identity?.customer_scope,
          type: identityDetails?.digital_identity?.type,
          value: identityDetails?.digital_identity?.value,
          language: identityDetails?.digital_identity?.language,
          contactEmail: identityDetails?.digital_identity?.contact_email,
        }}
      />
      <DeleteIdentityModal
        modalOpen={openDeleteModal}
        setModalOpen={setOpenDeleteModal}
        onDelete={handleDeleteIdentity}
        loading={loading}
      />
      <CocoLinkGeneratorModal
        isCocoLinkGeneratorOpen={isCocoLinkGeneratorOpen}
        setIsCocoLinkGeneratorOpen={setIsCocoLinkGeneratorOpen}
        user={{
          salutation: identityDetails?.digital_identity?.salutation,
          controllerCode: identityDetails?.digital_identity?.controller_code,
          customerScope: identityDetails?.digital_identity?.customer_scope,
          language: identityDetails?.digital_identity?.language,
          first_name: identityDetails?.digital_identity?.first_name,
          last_name: identityDetails?.digital_identity?.last_name,
          title: identityDetails?.digital_identity?.title,
          sub_identities: identityDetails?.digital_identity?.sub_identities,
          aliases: identityDetails?.digital_identity?.aliases,
          sourceSystem: identityDetails?.digital_identity?.type,
          value: identityDetails?.digital_identity?.value,
          contact_email: identityDetails?.digital_identity?.contact_email,
        }}
      />
    </>
  );
};

export default DetailPage;
